import $ from 'jquery';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import GLightbox from 'glightbox';
import Plyr from 'plyr/dist/plyr';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { $Elements, Animations, Durations, Events } from './constants';
import { fixMobileHover, isTouchScreen, setCookiesAllowed, setDisclaimerAccepted, smoothScrollTo, sortAnimations } from './helpers';

// ---------- LazyLoad Config ----------

lazySizes.cfg.throttleDelay = 66;
lazySizes.cfg.preloadAfterLoad = true;

// ---------- Fix Scroll ----------

history.scrollRestoration = "manual";

// ---------- Touch Screen ----------

if(isTouchScreen()) {
	$Elements.html.addClass('touchscreen');
}

// ---------- Fix VH ----------

$Elements.window.on('resize', () => document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`));
$Elements.window.trigger('resize');

// ---------- jQuery Related ----------

$Elements.document.on(Events.page.enter, () => {

	// ---------- Fix Mobile Hover ----------

	fixMobileHover();

	// ---------- Handle Aniamtions ----------

	ScrollTrigger.matchMedia(sortAnimations(Animations));

	// ---------- Links ----------

	$Elements.PageWrapper.on('click', 'a[href="#"], .void-link', (e) => e.preventDefault());

	$Elements.PageWrapper.on('click', '[data-scroll-to], [target="scroll-to"]', function(e) {
		e.preventDefault();

		const self = $(this);
		const target = (self.is('a')) ? $(self.attr('href')) : $(self.data('scroll-to'));

		if(target.length) {
			smoothScrollTo(target, Durations.animations.s);
		}
	});

	$Elements.PageWrapper.on('click', '.select-dropdown .dropdown-menu .btn', function() {
		$(this).closest('.dropdown').find('.dropdown-toggle').html($(this).text());
	});

	// ---------- GLightbox ----------

	$('[target="lightbox"]').each(function() {

		if($(this).attr('data-size') === 'full') {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			GLightbox({
				selector: 'a[href="' + this.attributes.href.value + '"][target="lightbox"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}
	});

	$('[target^="lightbox-gallery"]').each(function() {

		if($(this).attr('data-size') === 'full') {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"][data-size="full"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				width: 'auto',
				height: 'auto',
				videosWidth: 1280,
				skin: 'fullscreen',
			});
		}
		else {

			GLightbox({
				selector: 'a[target="' + this.attributes.target.value + '"]',
				openEffect: 'fade',
				closeEffect: 'fade',
				videosWidth: 1280,
			});
		}
	});

	// ---------- Disclaimer ----------

	$('#disclaimer').on('close.bs.alert', function() {
		setDisclaimerAccepted();
		$Elements.body.removeClass('disclaimer-open');
	});

	// ---------- Cookies ----------

	$('#cookies-allowed').on('click', '[data-bs-dismiss="alert"]', function() {
		setCookiesAllowed(this.dataset.allowed);
	});

	// ---------- Videos ----------

	$('.plyr__video-embed, .plyr-video').each(function() {

		new Plyr(this, {
			controls: [
				'play-large',
				'play',
				'progress',
				'current-time',
				'mute',
				'volume',
				'captions',
				'settings',
				'fullscreen'
			],
			settings: ['captions', 'quality', 'speed'],
			i18n: {
				restart: 'Recommencer',
				rewind: 'Reculer de {seektime}s',
				play: 'Lecture',
				pause: 'Pause',
				fastForward: 'Avancer de {seektime}s',
				seek: 'Rechercher',
				seekLabel: '{currentTime} de {duration}',
				played: 'Lu',
				buffered: 'Mis en mémoire tampon',
				currentTime: 'Temps actuel',
				duration: 'Durée',
				volume: 'Volume',
				mute: 'Muet',
				unmute: 'Activer le son',
				enableCaptions: 'Activer les sous-titres',
				disableCaptions: 'Désactiver les sous-titres',
				enterFullscreen: 'Plein écran',
				exitFullscreen: 'Quitter le plein écran',
				settings: 'Paramètres',
				speed: 'Vitesse',
				normal: 'Normal',
				quality: 'Qualité'
			}
		});
	});

	// ---------- Modals ----------

	$('.modal:not(.password-modal)').click(function(event) {
		$(event.target).modal('hide');
	});

	if($('#informations-modal').length) {
		$('#informations-modal').modal('toggle');
	}

	if($('#password-modal').length) {
		$('#password-modal').modal('show');
	}
});
